import * as React from 'react';

import { Box, Flex } from '@lightspeed/flame/Core';

import { StatusDataContext } from 'root/apps/InventoryCount/contexts/StatusData';

import { StyledSelected, StyledUnselected } from './Stepper.style';

const Stepper: React.FC = () => {
  const { data } = React.useContext(StatusDataContext);
  const [status, setStatus] = React.useState<string | undefined>('');

  React.useEffect(() => {
    setStatus(data?.status);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.status]);

  const uploadView = ['awaiting_upload', 'validation_failed', 'import_success'];
  const mapColumnsView = ['awaiting_input'];
  const validationView = ['awaiting_validation', 'validation_queued', 'validation_running'];
  const importOverviewView = ['ready_to_import', 'import_failed'];
  const importProgressView = ['awaiting_import', 'import_queued', 'import_running'];

  const stepperCheck = (currentStatus: string | undefined, list: string[]) => {
    if (currentStatus) {
      const isStatusAvailable = list.includes(currentStatus);
      return isStatusAvailable;
    }
    return false;
  };

  return (
    <Box p={2}>
      <Flex justifyContent="center">
        {stepperCheck(status, uploadView) ? <StyledSelected /> : <StyledUnselected />}
        {stepperCheck(status, mapColumnsView) ? <StyledSelected /> : <StyledUnselected />}
        {stepperCheck(status, validationView) ? <StyledSelected /> : <StyledUnselected />}
        {stepperCheck(status, importOverviewView) ? <StyledSelected /> : <StyledUnselected />}
        {stepperCheck(status, importProgressView) ? <StyledSelected /> : <StyledUnselected />}
      </Flex>
    </Box>
  );
};

export default Stepper;
